import clsx from "clsx";
import { ReactNode } from "react";
import {
  ButtonRecipeProps,
  buttonStyles,
} from "../../buttons/Button/Button.recipe";
import BaseLink from "../BaseLink";
import type { LinkProps } from "../types";

export type ButtonLinkProps = LinkProps &
  ButtonRecipeProps & {
    children: ReactNode;
  };

/** Link component styled like a Button for navigation */
const ButtonLink = ({
  appearance,
  children,
  className,
  fullWidth,
  noWrap,
  size,
  ...props
}: ButtonLinkProps) => (
  <BaseLink
    {...props}
    className={clsx(
      buttonStyles({ appearance, fullWidth, noWrap, size }),
      className,
    )}
  >
    {children}
  </BaseLink>
);

export default ButtonLink;
